$(document).on("autocomplete", ".trainee-selector .trainee-name", onTraineeAutocomplete);

document.addEventListener("DOMContentLoaded", function () {
  if ($(".trainee-selector").length > 0) {
    checkIfTraineeSelected();
  }
});

function checkIfTraineeSelected() {
  let trainee_id = getQueryParameter("trainee_id");
  let trainee_lastname = getQueryParameter("trainee_lastname");
  let trainee_firstname = getQueryParameter("trainee_firstname");
  if (trainee_id != null && trainee_id != "") {
    let trainee_name = [trainee_firstname, trainee_lastname].join(" ");
    $(".trainee-selector .trainee-id").val(trainee_id);
    $(".trainee-selector .trainee-name").val(trainee_name);
  }
}

function onTraineeAutocomplete({ detail: trainee }) {
  if (trainee) {
    $(".trainee-selector .trainee-id").val(trainee.id);
  } else {
    $(".trainee-selector .trainee-id").val("");
  }
}
